import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { RoleInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { RoleDetailSaveModel } from '../../role-details/models/role-detail-save.model';
import { SaveRole, SaveRoleVariables } from '../../role-details/queries/generated/SaveRole';
import { SaveRoleMutation } from '../../role-details/queries/save-role.graphql';

@Injectable({ providedIn: 'root' })
export class AddRoleApiService {
   constructor(private apiService: LcsApiService) {}

   create(roleDetail: RoleDetailSaveModel): Observable<ExecutionResult<SaveRole>> {
      const fields: (keyof RoleInput)[] = ['name', 'description', 'accountId'];

      return this.apiService.query<SaveRole, SaveRoleVariables>({
         query: SaveRoleMutation,
         variables: {
            deletedRoleReportIds: [],
            deletedRolePrivilegeIds: [],
            role: {
               ...roleDetail,
               roleReports: [],
               fields: fields,
            },
            rolePrivileges: [],
            deletedRoleCallRecordingExtensionIds: [],
            deletedRoleCallRecordingExtensionGroupIds: [],
         },
      });
   }
}
